
import { IconButton } from '@mui/material'
import { Box } from '@mui/system'
import { useState } from 'react'
import { customTheme as theme } from '../../../theme/customTheme'; 
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { makeStyles } from '@mui/styles';
import CustomCropperModal from './CustomCropperModal';
import { useSelector } from 'react-redux';


export const CustomLogoUploader = (props) => {
    const {  onSubmitImage, isLogo, setIsLogo,  image, setImage, defaultImage } = props
    const classes = useStyles();
    const [display, setDisplay] = useState("notdisplayed");
    const commonReducer = useSelector((state) => state.root.commonReducer);
  
    const [cropperFlag, setCropperFlag] = useState(false);

    const showButton = e => {
        e.preventDefault();
        setDisplay("displayed");
    };

    const hideButton = e => {
        e.preventDefault();
        setDisplay("notdisplayed");
    };

    const onChange = (e) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result);  
            setCropperFlag(true)
        };
        if(files[0]){
            reader.readAsDataURL(files[0]);
        }
    };

    const dataUrlToFile = async (dataUrl, fileName) => {
        const res = await fetch(dataUrl);
        const buf = await res.arrayBuffer();
        return new File([buf], fileName, { type: 'image/png' });
    }

    const onLogoSubmit = (acceptedFilesData) => {
        // console.log(acceptedFilesData)
        dataUrlToFile(acceptedFilesData, `${commonReducer?.company_name}_logo_${Date.now()}.png`).then((res) => {
            // setImage(res)
           
            setIsLogo({ path: acceptedFilesData, flag: true });
            onSubmitImage(acceptedFilesData, res)
        })
    };

    return <>
        <Box className={classes.logo} elevation={5} sx={{width:'100%', height:'100%'}}>
            {
                isLogo?.flag ? <Box
                    onMouseEnter={e => showButton(e)}
                    onMouseLeave={e => hideButton(e)}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        // width: imageWrapperWidth,
                        width:'100%',
                        // height: imageWrapperHeight,
                        backgroundColor: "#ddd",
                        fontSize: 65,
                        fontWeight: 700,
                        position: "relative",
                      border:'1px solid black'
                    }}>
                    {
                        <img src={isLogo?.path} className={classes.img}  onLoad={() => { URL.revokeObjectURL(isLogo?.path) }}  />
                    }
                    {
                        // display == "displayed" &&
                        <Box className={classes.editLogo} sx={{ display: `${display == "displayed" ? "block" : "none"}` }}>
                            <input accept="image/*" className={classes.input} id="icon-button-file" type="file" onChange={onChange} />
                            <label htmlFor="icon-button-file" style={{ display: "block", "lineHeight": 1 }}>
                                <IconButton  aria-label="upload picture" component="span" style={{ display: "block" }}>
                                    <EditOutlinedIcon   fontSize="small" style={{ color: "#fff",  }} />
                                </IconButton>
                            </label>
                        </Box>
                    }
                </Box>
                    :
                    <Box
                    onMouseEnter={e => showButton(e)}
                    onMouseLeave={e => hideButton(e)}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        // width: imageWrapperWidth,
                        width:'100%',
                        // height: imageWrapperHeight,
                        backgroundColor: "#ddd",
                        fontSize: 65,
                        fontWeight: 700,
                        position: "relative",
                        border:'1px solid black',
                        borderRadius:'5px',
                        // padding:'4px'
                    }}>
                    {
                        <img src={defaultImage} className={classes.img}/>
                    }
                    {
                        // display == "displayed" &&
                        <Box className={classes.editLogo} sx={{ display: `${display == "displayed" ? "block" : "none"}` }}>
                            <input accept="image/*" className={classes.input} id="icon-button-file" type="file" onChange={onChange} />
                            <label htmlFor="icon-button-file" style={{ display: "block", "lineHeight": 1 }}>
                                <IconButton color="primary" aria-label="upload picture" component="span" style={{ display: "block" }}>
                                    <EditOutlinedIcon fontSize="medium" style={{ color: "#fff" }} />
                                </IconButton>
                            </label>
                        </Box>
                    }
                </Box>
            }
        </Box>
        {
            cropperFlag && <CustomCropperModal openHandler={cropperFlag} toggleHandler={setCropperFlag} image={image} setImage={setImage} onChange={onChange} onSubmitImage={onLogoSubmit} />
        }
    </>
}


const useStyles = makeStyles(theme => ({
    logo: {
        borderRadius: '50% !important',
        maxWidth: '100%',
        // height: 210,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // minWidth: 210,
        flexDirection: "column"

    },
    modal: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    displayed: {
        display: "flex",
        height: "20px",
        margin: "auto",
    },
    notdisplayed: {
        display: "none"
    },
    input: {
        display: 'none',
    },
    body: {
    },
    editIcon: {
        position: "absolute",
        height: "45px",
        width: "100%",
        right: 0,
        padding: 0,
        top: "auto",
        left: 0,
        bottom: 0,
        textAlign: "center"
    },
    img: {
        borderRadius: 5,
        aspectRatio: 7/3,
        width: "100%",
        // height: "100%",
        objectFit: "contain"
    },
    logo: {
        borderRadius: '50%',
        maxWidth: '90%',
        // height: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: "column"
    },
    editLogo: {
        padding: "0",
        position: "absolute",
        width: "100%",
        textAlign: "center",
        top: "auto",
        bottom: 0,
        background: "#00000060"
    },
}));